/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ActorDefs from './..\\actor\\defs.defs.js'
import * as FeedDefs from './..\\feed\\defs.defs.js'

const $nsid = 'app.bsky.unspecced.defs'

type $nsid = typeof $nsid

export { $nsid }

type SkeletonSearchPost = {
  $type?: 'app.bsky.unspecced.defs#skeletonSearchPost'
  uri: l.AtUriString
}

export type { SkeletonSearchPost }

const skeletonSearchPost = /*#__PURE__*/ l.typedObject<SkeletonSearchPost>(
  $nsid,
  'skeletonSearchPost',
  /*#__PURE__*/ l.object({ uri: /*#__PURE__*/ l.string({ format: 'at-uri' }) }),
)

export { skeletonSearchPost }

type SkeletonSearchActor = {
  $type?: 'app.bsky.unspecced.defs#skeletonSearchActor'
  did: l.DidString
}

export type { SkeletonSearchActor }

const skeletonSearchActor = /*#__PURE__*/ l.typedObject<SkeletonSearchActor>(
  $nsid,
  'skeletonSearchActor',
  /*#__PURE__*/ l.object({ did: /*#__PURE__*/ l.string({ format: 'did' }) }),
)

export { skeletonSearchActor }

type SkeletonSearchStarterPack = {
  $type?: 'app.bsky.unspecced.defs#skeletonSearchStarterPack'
  uri: l.AtUriString
}

export type { SkeletonSearchStarterPack }

const skeletonSearchStarterPack =
  /*#__PURE__*/ l.typedObject<SkeletonSearchStarterPack>(
    $nsid,
    'skeletonSearchStarterPack',
    /*#__PURE__*/ l.object({
      uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    }),
  )

export { skeletonSearchStarterPack }

type TrendingTopic = {
  $type?: 'app.bsky.unspecced.defs#trendingTopic'
  topic: string
  displayName?: string
  description?: string
  link: string
}

export type { TrendingTopic }

const trendingTopic = /*#__PURE__*/ l.typedObject<TrendingTopic>(
  $nsid,
  'trendingTopic',
  /*#__PURE__*/ l.object({
    topic: /*#__PURE__*/ l.string(),
    displayName: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    description: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    link: /*#__PURE__*/ l.string(),
  }),
)

export { trendingTopic }

type SkeletonTrend = {
  $type?: 'app.bsky.unspecced.defs#skeletonTrend'
  topic: string
  displayName: string
  description?: string
  link: string
  startedAt: l.DatetimeString
  postCount: number
  status?: 'hot' | l.UnknownString
  category?: string
  dids: l.DidString[]
}

export type { SkeletonTrend }

const skeletonTrend = /*#__PURE__*/ l.typedObject<SkeletonTrend>(
  $nsid,
  'skeletonTrend',
  /*#__PURE__*/ l.object({
    topic: /*#__PURE__*/ l.string(),
    displayName: /*#__PURE__*/ l.string(),
    description: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    link: /*#__PURE__*/ l.string(),
    startedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    postCount: /*#__PURE__*/ l.integer(),
    status: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{ knownValues: ['hot'] }>(),
    ),
    category: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    dids: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'did' })),
  }),
)

export { skeletonTrend }

type TrendView = {
  $type?: 'app.bsky.unspecced.defs#trendView'
  topic: string
  displayName: string
  description?: string
  link: string
  startedAt: l.DatetimeString
  postCount: number
  status?: 'hot' | l.UnknownString
  category?: string
  actors: ActorDefs.ProfileViewBasic[]
}

export type { TrendView }

const trendView = /*#__PURE__*/ l.typedObject<TrendView>(
  $nsid,
  'trendView',
  /*#__PURE__*/ l.object({
    topic: /*#__PURE__*/ l.string(),
    displayName: /*#__PURE__*/ l.string(),
    description: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    link: /*#__PURE__*/ l.string(),
    startedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    postCount: /*#__PURE__*/ l.integer(),
    status: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{ knownValues: ['hot'] }>(),
    ),
    category: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    actors: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>(
        (() => ActorDefs.profileViewBasic) as any,
      ),
    ),
  }),
)

export { trendView }

type ThreadItemPost = {
  $type?: 'app.bsky.unspecced.defs#threadItemPost'
  post: FeedDefs.PostView

  /**
   * This post has more parents that were not present in the response. This is just a boolean, without the number of parents.
   */
  moreParents: boolean

  /**
   * This post has more replies that were not present in the response. This is a numeric value, which is best-effort and might not be accurate.
   */
  moreReplies: number

  /**
   * This post is part of a contiguous thread by the OP from the thread root. Sub-threads by OP deeper in the tree are not considered an OP thread.
   */
  opThread: boolean

  /**
   * The 1-indexed position of this post within the contiguous OP thread. Only present when this post is part of the OP thread (see `opThread`).
   */
  opThreadPostIndex?: number

  /**
   * The total number of posts in the contiguous OP thread that this post belongs to. Only present when this post is part of the OP thread (see `opThread`).
   */
  opThreadPostCount?: number

  /**
   * The threadgate created by the author indicates this post as a reply to be hidden for everyone consuming the thread.
   */
  hiddenByThreadgate: boolean

  /**
   * This is by an account muted by the viewer requesting it.
   */
  mutedByViewer: boolean
}

export type { ThreadItemPost }

const threadItemPost = /*#__PURE__*/ l.typedObject<ThreadItemPost>(
  $nsid,
  'threadItemPost',
  /*#__PURE__*/ l.object({
    post: /*#__PURE__*/ l.ref<FeedDefs.PostView>(
      (() => FeedDefs.postView) as any,
    ),
    moreParents: /*#__PURE__*/ l.boolean(),
    moreReplies: /*#__PURE__*/ l.integer(),
    opThread: /*#__PURE__*/ l.boolean(),
    opThreadPostIndex: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    opThreadPostCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    hiddenByThreadgate: /*#__PURE__*/ l.boolean(),
    mutedByViewer: /*#__PURE__*/ l.boolean(),
  }),
)

export { threadItemPost }

type ThreadItemNoUnauthenticated = {
  $type?: 'app.bsky.unspecced.defs#threadItemNoUnauthenticated'
}

export type { ThreadItemNoUnauthenticated }

const threadItemNoUnauthenticated =
  /*#__PURE__*/ l.typedObject<ThreadItemNoUnauthenticated>(
    $nsid,
    'threadItemNoUnauthenticated',
    /*#__PURE__*/ l.object({}),
  )

export { threadItemNoUnauthenticated }

type ThreadItemNotFound = {
  $type?: 'app.bsky.unspecced.defs#threadItemNotFound'
}

export type { ThreadItemNotFound }

const threadItemNotFound = /*#__PURE__*/ l.typedObject<ThreadItemNotFound>(
  $nsid,
  'threadItemNotFound',
  /*#__PURE__*/ l.object({}),
)

export { threadItemNotFound }

type ThreadItemBlocked = {
  $type?: 'app.bsky.unspecced.defs#threadItemBlocked'
  author: FeedDefs.BlockedAuthor
}

export type { ThreadItemBlocked }

const threadItemBlocked = /*#__PURE__*/ l.typedObject<ThreadItemBlocked>(
  $nsid,
  'threadItemBlocked',
  /*#__PURE__*/ l.object({
    author: /*#__PURE__*/ l.ref<FeedDefs.BlockedAuthor>(
      (() => FeedDefs.blockedAuthor) as any,
    ),
  }),
)

export { threadItemBlocked }

/** The computed state of the age assurance process, returned to the user in question on certain authenticated requests. */
type AgeAssuranceState = {
  $type?: 'app.bsky.unspecced.defs#ageAssuranceState'

  /**
   * The timestamp when this state was last updated.
   */
  lastInitiatedAt?: l.DatetimeString

  /**
   * The status of the age assurance process.
   */
  status: 'unknown' | 'pending' | 'assured' | 'blocked' | l.UnknownString
}

export type { AgeAssuranceState }

/** The computed state of the age assurance process, returned to the user in question on certain authenticated requests. */
const ageAssuranceState = /*#__PURE__*/ l.typedObject<AgeAssuranceState>(
  $nsid,
  'ageAssuranceState',
  /*#__PURE__*/ l.object({
    lastInitiatedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    status: /*#__PURE__*/ l.string<{
      knownValues: ['unknown', 'pending', 'assured', 'blocked']
    }>(),
  }),
)

export { ageAssuranceState }

/** Object used to store age assurance data in stash. */
type AgeAssuranceEvent = {
  $type?: 'app.bsky.unspecced.defs#ageAssuranceEvent'

  /**
   * The date and time of this write operation.
   */
  createdAt: l.DatetimeString

  /**
   * The status of the age assurance process.
   */
  status: 'unknown' | 'pending' | 'assured' | l.UnknownString

  /**
   * The unique identifier for this instance of the age assurance flow, in UUID format.
   */
  attemptId: string

  /**
   * The email used for AA.
   */
  email?: string

  /**
   * The IP address used when initiating the AA flow.
   */
  initIp?: string

  /**
   * The user agent used when initiating the AA flow.
   */
  initUa?: string

  /**
   * The IP address used when completing the AA flow.
   */
  completeIp?: string

  /**
   * The user agent used when completing the AA flow.
   */
  completeUa?: string
}

export type { AgeAssuranceEvent }

/** Object used to store age assurance data in stash. */
const ageAssuranceEvent = /*#__PURE__*/ l.typedObject<AgeAssuranceEvent>(
  $nsid,
  'ageAssuranceEvent',
  /*#__PURE__*/ l.object({
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    status: /*#__PURE__*/ l.string<{
      knownValues: ['unknown', 'pending', 'assured']
    }>(),
    attemptId: /*#__PURE__*/ l.string(),
    email: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    initIp: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    initUa: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    completeIp: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    completeUa: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { ageAssuranceEvent }
